Ext.define('SA.SidebarLogo', {
    constructor() {
        Ext.getBody().appendChild({cls: 'sa-sidebar-logo sa-sidebar-logo-dark'});

        this.lightLogo = Ext.getBody().appendChild({cls: 'sa-sidebar-logo sa-sidebar-logo-light'});
    },

    useDark() {
        this.lightLogo.addCls('sa-sidebar-logo-hidden');
    },

    useLight() {
        this.lightLogo.removeCls('sa-sidebar-logo-hidden');
    }
});